import { memo, FunctionComponent, SVGProps } from 'react';
import iconList from './iconList';
import { StyledIconContainer } from './styles';

export type IconProps = {
  name:
    | 'dollarCoinActive'
    | 'caretLeft'
    | 'images'
    | 'imagesActive'
    | 'trash'
    | 'eye'
    | 'eyeClosed'
    | 'key'
    | 'mail'
    | 'union'
    | 'caret'
    | 'watch'
    | 'calendar'
    | 'calendarInactive'
    | 'user'
    | 'users'
    | 'book'
    | 'account'
    | 'arrow'
    | 'bigFork'
    | 'fork'
    | 'forkInactive'
    | 'location'
    | 'phone'
    | 'coin'
    | 'warning'
    | 'camera'
    | 'plus'
    | 'check'
    | 'home'
    | 'homeInactive'
    | 'business'
    | 'businessActive'
    | 'iceCream'
    | 'iceCreamActive'
    | 'salad'
    | 'saladActive'
    | 'sidebarMenu'
    | 'bigCheckBox'
    | 'bigInfo'
    | 'bigCross'
    | 'wheel'
    | 'wheelActive'
    | 'success'
    | 'pencil';
};

const IconComponent = ({
  name,
  onClick,
  ...otherProps
}: IconProps & Omit<SVGProps<SVGSVGElement>, 'name' | 'onClick'> & { onClick?: () => void }) => {
  const SvgComponent = iconList[name] as FunctionComponent<SVGProps<SVGSVGElement>> | undefined;

  if (!SvgComponent) {
    return null;
  }

  return (
    <StyledIconContainer onClick={onClick} hasOnClick={!!onClick}>
      <SvgComponent role="img" {...otherProps} />
    </StyledIconContainer>
  );
};

const Icon = memo(IconComponent);
Icon.displayName = 'Icon';

export default Icon;
